import { render, staticRenderFns } from "./price-reductions.vue?vue&type=template&id=46536db0"
import script from "./price-reductions.vue?vue&type=script&lang=js"
export * from "./price-reductions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports